import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Moon } from "lucide-react";
import { api } from "@/lib/api";

const Col = ({ label, d, testId }) => (
  <div className="mm-soft p-4 flex-1" data-testid={testId}>
    <div className="text-xs text-mm-muted mb-1">{label}</div>
    <div className="text-2xl font-bold">{d.hours ?? "—"}<span className="text-sm font-normal text-mm-muted"> h</span></div>
    <div className="text-sm text-mm-muted">Quality {d.quality ?? "—"} / 5</div>
  </div>
);

// Sleep after wind-down nights vs other nights (needs 5 of each)
export const SleepCompare = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/bedtime/sleep-compare").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="mm-card p-5" data-testid="insights-sleep-compare">
      <div className="flex items-center gap-2 font-semibold mb-3"><Moon size={18} className="text-mm-primary" />Sleep after winding down</div>
      {d.ready ? (
        <div className="flex gap-3"><Col label={`After wind-down (${d.winddown_nights} nights)`} d={d.winddown} testId="sleep-compare-winddown" /><Col label={`Other nights (${d.other_nights})`} d={d.other} testId="sleep-compare-other" /></div>
      ) : (
        <p className="text-sm text-mm-muted" data-testid="sleep-compare-pending">
          Once you have {d.min_nights} wind-down nights and {d.min_nights} other nights with sleep logged, you'll see how they compare.
          So far: {d.winddown_nights} wind-down, {d.other_nights} other. <Link to="/bedtime" className="text-mm-primary font-semibold">Try tonight</Link>
        </p>
      )}
    </div>
  );
};
